package devxertech.com.pages.industries.devIndustryEdu.educationSpotLight

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.TeamService
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun SpotLightEducation(breakpoint: Breakpoint,
               sitePalette: SitePalette){
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 60.px,
                bottom = if (breakpoint < Breakpoint.MD) 10.px else 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "EDUCATIONAL SOFTWARE DEVELOPMENT SERVICES",
                asH2 = true,
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 18.px else 15.px,
                textAlign = TextAlign.Center
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "Our Services ",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700,
                    textTransform = TextTransform.Uppercase
                )
                FieldTitleTextNormalSimple(
                    " In The Spotlight",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700,
                    textTransform = TextTransform.Uppercase
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(bottom = if (breakpoint < Breakpoint.MD) 0.px else if (window.screen.width > 1600) 10.px else 0.px,
                        top = if (breakpoint < Breakpoint.MD) 20.px else 40.px).flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                TeamService(
                    image = Res.Image.industry_light_1,
                    title = "Community Management",
                    description = " We build interactive and collaborative platforms for effective community " +
                            "management of students and teachers so that the spaces remain segregated and" +
                            " give their full potential in every aspect.",
                )
                TeamService(
                    image = Res.Image.industry_light_2,
                    title = "Virtual Reality Solutions",
                    description = "Devxer proudly provides virtual reality solutions for an enhanced " +
                            "student learning, engagement and exceptional content delivery. Our virtual " +
                            "reality solutions aim to build more motivation, efficient learning and meaningful " +
                            "interactions among all the students.\n",
                )
                TeamService(
                    image = Res.Image.industry_light_3,
                    title = "Student and Teacher\n" +
                            " Portals",
                    description = "In this century of digital learning, we offer our coveted services for fully " +
                            "customized, intelligent and integrated student and teacher portals so " +
                            "that the knowledge and information flow remains uninterrupted, smooth and easy.",
                )
                if (window.screen.width < 1600) {
                    TeamService(
                        image = Res.Image.industry_light_4,
                        title = "Database Management \n" +
                                "System",
                        description = "Developing education management software requires accumulation " +
                                "and organization of huge data chunks so that the information can be " +
                                "used effectively. Our services for student/teacher data base management" +
                                " are bound to provide a strong and seamless platform for storing records.",
                        modifier = Modifier.margin(bottom = 20.px)
                    )


                    TeamService(
                        image = Res.Image.industry_light_5,
                        title = "Learning Management \n" +
                                "System",
                        description = "Our learning management software services are highly functional yet innovative " +
                                "which enable the platform to perform tasks like administration, documentation, " +
                                "tracking and delivery of educational course with efficiency and ease. ",
                        modifier = Modifier.padding(bottom = 40.px)

                    )
                }
            }
            if (window.screen.width > 1600) {
                Row(modifier = Modifier.fillMaxWidth()
                    .padding(top = 0.px, bottom = if (window.screen.width > 1600) 0.px else 70.px).display(DisplayStyle.Flex)
                    .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TeamService(
                        image = Res.Image.industry_light_4,
                        title = "Database Management \n" +
                                "System",
                        description = "Developing education management software requires accumulation and " +
                                "organization of huge data chunks so that the information can be used effectively. " +
                                "Our services for student/teacher data base management are bound to provide a strong " +
                                "and seamless platform for storing records.",
                        modifier = Modifier.padding(bottom = 10.px)

                    )
                    TeamService(
                        image = Res.Image.industry_light_5,
                        title = "Learning Management \n" +
                                "System",
                        description = "Our learning management software services are highly functional yet innovative " +
                                "which enable the platform to perform tasks like administration, documentation, " +
                                "tracking and delivery of educational course with efficiency and ease. ",
                        modifier = Modifier.padding(bottom = 40.px)

                    )
                }
            }
        }
    }
}
